import React, { useEffect, useState } from 'react';
import authService from 'src/services/authService';

const UpdateProfilePopup = ({ isOpen, onClose, profilePictureDetails }) => {
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [formData, setFormData] = useState({
        image: null,
        profilePicture: profilePictureDetails.image_url,

        name: profilePictureDetails.full_name,
        password: "",
    });
    const [validationMessages, setValidationMessages] = useState({

        name: '',

    });



    const handleChange = (e) => {
        if (e.target.type === 'file') {
            setFormData({
                ...formData,
                image: e.target.files[0], // Store the file object
            });
        } else {
            const { name, value } = e.target;
            setFormData({
                ...formData,
                [name]: value, // Store the value for other inputs
            });
        }
    };

    const handleSubmit = (e) => {

        // Perform form validation
        const newValidationMessages = {};

        if (!formData.name) {
            newValidationMessages.name = 'Name is required';
        }

        if (!formData.password && showChangePassword) {
            newValidationMessages.password = 'Password is required';
        }

        setValidationMessages(newValidationMessages);

        // If all fields are valid, submit the form
        if (Object.keys(newValidationMessages).length === 0) {
            const updateDetails = {
                "full_name": formData.name,
                "image_url": formData.profilePicture,
                "password": formData.password,
                "email": profilePictureDetails.email
            }
            authService.updateUserDetail(updateDetails)
                .then((res) => {
                    if (res.status == 200) {
                        window.location.reload();
                    }
                })

        }
    };

    const uploadProfilePicture = () => {
        const data = new FormData();
        data.append('image', formData.image);
        authService.uploadProfilePicture(data)
            .then((res) => {
                if (res.status == 200) {
                    setFormData({
                        ...formData,
                        profilePicture: res.data.image_url
                    });
                }
            })
    }

    useEffect(() => {
        if (formData.image != null) {
            uploadProfilePicture();
        }

    }, [formData.image])

    const handleShowChangePassword = () => {
        setShowChangePassword(!showChangePassword);
    };
    return (
        <div className={`fixed inset-0 flex items-center justify-center bg-opacity-50 backdrop-filter backdrop-blur-lg ${isOpen ? 'visible' : 'hidden'}`}>
            <div className="bg-white rounded-lg p-8 max-w-md">
                <button className="absolute top-0 right-0 p-2" onClick={onClose}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
                <h2 className="text-2xl font-bold mb-4">User Profile</h2>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Profile Picture</label>
                    <input
                        type="file"
                        accept="image/*"
                        name="profilePicture"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                        onChange={handleChange}
                    />
                    {formData.profilePicture && (
                        <img src={formData.profilePicture} alt="Uploaded" className="mb-4" />
                    )}
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Name</label>
                    <input
                        type="text"
                        name="name"
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <p className="text-red-500">{validationMessages.name}</p>
                </div>
                {showChangePassword && (
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Password</label>
                        <input
                            type="password"
                            name="password"
                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                            value={formData.password}
                            onChange={handleChange}
                        />
                        <p className="text-red-500">{validationMessages.password}</p>
                    </div>
                )}

                <button
                    type="button"
                    onClick={handleShowChangePassword}
                    className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600 mb-10"
                >
                    Change Password
                </button>
                <br />
                <button
                    onClick={onClose}
                    className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 focus:outline-none focus:bg-indigo-600"
                >
                    Cancel
                </button>
                <button
                    onClick={(e) => handleSubmit(e)}
                    className="bg-indigo-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
                >
                    Update
                </button>

            </div>
        </div>
    );
};

export default UpdateProfilePopup;